import axiosInstance from "@/config/axios";

export const getSOEByTaxRis = async (payload: {taxpayerId : string}) =>{
    const {data} = await axiosInstance.post("/auth/tax-ris-api", payload);
    return data

}